<!-- 基于ele-pagination，字典可直接参考element-ui 组件
    目前主要功能均可用，还有以下功能需要后期完善：
    1 自动布局: layout
    2 自动具右布局：rightWrapper
    3 每页条数自动设置：size
 -->
<template>
    <div class='paginationbox' v-if="internalPageCount && internalPageCount > 1">
       <!-- <prev></prev> -->
       <div
           type="button"
           class="box box-prev"
           :class="{ disabled: internalCurrentPage <= 1 }"
           @click="prev">
           上页
       </div>
        <!-- <prev></prev> -->

       <pager :current-page="internalCurrentPage" :page-count="internalPageCount" v-on:change="handleCurrentChange"></pager>

       <!-- <next></next> -->
        <div
            type="button"
            class="box box-next"
            :class="{ disabled: internalCurrentPage === internalPageCount || internalPageCount === 0 }"
            @click="next">
            下页
        </div>
        <!-- <next></next> -->

        <!--<page></page> -->
        <div
            style="cursor: auto;"
            type="button"
            class="box"
            >
            共{{internalPageCount}}页
        </div>
        <!--<page></page> -->

        <!-- <jumper></jumper> -->
        <template v-if="goVisible">
            <span class="page-goto-title">GO</span>
            <div class="box-input">
                <input type="text" class="goto_page" :value="internalCurrentPage" v-on:change="gotoPage($event)">
            </div>
        </template>
        <!-- <jumper></jumper> -->

       <!-- <sizes :pageSizes="pageSizes"></sizes> -->

       <!-- <my-slot></my-slot> -->
       <slot name="myslot"></slot>
       <!-- <my-slot></my-slot> -->

       <!-- <total></total> -->
       <div v-if="totalVisible" class="box-total">共&nbsp;{{ total }}&nbsp;条</div>
       <!-- <total></total> -->

    </div>
</template>

<script type="text/javascript">
import pager from './pager'

export default {
    name: 'Pagination',
    data: function () {
        return {
            internalCurrentPage: 1,
            internalPageSize: 0
        }
    },
    props: {
        pageSize: {
            type: Number,
            default: 10
        },

        small: Boolean,

        total: Number,

        pageCount: Number,

        currentPage: {
            type: Number,
            default: 1
        },

        layout: {
            default: 'prev, pager, next, jumper, ->, total'
        },

        pageSizes: {
            type: Array,
            default: function () {
                return [10, 20, 30, 40, 50, 100]
            }
        },

        goVisible: {
            type: Boolean,
            default: false
        },

        totalVisible: {
            type: Boolean,
            default: false
        }
    },

    components: {
        // MySlot: {
        //     template: this.$parent.$slots.default ? this.$parent.$slots.default[0] : ''
        // },
        // Prev: {
        //     render(h) {
        //         return (
        //             <button
        //             type="button"
        //             class={['btn-prev', { disabled: this.$parent.internalCurrentPage <= 1 }]}
        //             on-click={ this.$parent.prev }>
        //             <i class="el-icon el-icon-arrow-left"></i>
        //         </button>
        //         )
        //     }
        // },

        // Next: {
        //     render(h) {
        //         return (
        //             <button
        //             type="button"
        //             class={[
        //                 'btn-next',
        //                 { disabled: this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0 }
        //                 ]}
        //                 on-click={ this.$parent.next }>
        //                 <i class="el-icon el-icon-arrow-right"></i>
        //             </button>
        //             )
        //     }
        // },

        // Sizes: {
        //     mixins: [Locale],

        //     props: {
        //         pageSizes: Array
        //     },

        //     watch: {
        //         pageSizes: {
        //             immediate: true,
        //             handler(value) {
        //                 if (Array.isArray(value)) {
        //                     this.$parent.internalPageSize = value.indexOf(this.$parent.pageSize) > -1
        //                     ? this.$parent.pageSize
        //                     : this.pageSizes[0]
        //                 }
        //             }
        //         }
        //     },

        //     render(h) {
        //         return (
        //             <span class="el-pagination__sizes">
        //                 <el-select
        //                 value={ this.$parent.internalPageSize }
        //                 on-input={ this.handleChange }>
        //                 {
        //                     this.pageSizes.map(item =>
        //                         <el-option
        //                         value={ item }
        //                         label={ item + ' ' + this.t('el.pagination.pagesize') }>
        //                     </el-option>
        //                     )
        //                 }
        //             </el-select>
        //         </span>
        //         )
        //     },

        //     components: {
        //         ElSelect,
        //         ElOption
        //     },

        //     methods: {
        //         handleChange(val) {
        //             if (val !== this.$parent.internalPageSize) {
        //                 this.$parent.internalPageSize = val = parseInt(val, 10)
        //                 this.$parent.$emit('size-change', val)
        //             }
        //         }
        //     }
        // },

        // Jumper: {
        //     mixins: [Locale],

        //     data() {
        //         return {
        //             oldValue: null
        //         }
        //     },

        //     methods: {
        //         handleFocus(event) {
        //             this.oldValue = event.target.value
        //         },

        //         handleChange({ target }) {
        //             this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(target.value)
        //             this.oldValue = null
        //         }
        //     },

        //     render(h) {
        //         return (
        //         <span class="el-pagination__jump">
        //             { this.t('el.pagination.goto') }
        //             <input
        //             class="el-pagination__editor"
        //             type="number"
        //             min={ 1 }
        //             max={ this.internalPageCount }
        //             value={ this.$parent.internalCurrentPage }
        //             domProps-value={ this.$parent.internalCurrentPage }
        //             on-change={ this.handleChange }
        //             on-focus={ this.handleFocus }
        //             number/>
        //             { this.t('el.pagination.pageClassifier') }
        //         </span>
        //         )
        //     }
        // },

        // Total: {
        //     mixins: [Locale],

        //     render(h) {
        //         return (
        //         typeof this.$parent.total === 'number'
        //         ? <span class="el-pagination__total">{ this.t('el.pagination.total', { total: this.$parent.total }) }</span>
        //         : ''
        //         )
        //     }
        // },

        pager: pager
    },

    methods: {
        handleCurrentChange: function (val) {
            this.internalCurrentPage = this.getValidCurrentPage(val)
        },

        prev: function () {
            var newVal = this.internalCurrentPage - 1
            this.internalCurrentPage = this.getValidCurrentPage(newVal)
        },

        next: function () {
            var newVal = this.internalCurrentPage + 1
            this.internalCurrentPage = this.getValidCurrentPage(newVal)
        },

        getValidCurrentPage: function (value) {
            value = parseInt(value, 10)

            var havePageCount = typeof this.internalPageCount === 'number'

            var resetValue
            if (!havePageCount) {
                if (isNaN(value) || value < 1) resetValue = 1
            } else {
                if (value < 1) {
                    resetValue = 1
                } else if (value > this.internalPageCount) {
                    resetValue = this.internalPageCount
                }
            }

            if (resetValue === undefined && isNaN(value)) {
                resetValue = 1
            } else if (resetValue === 0) {
                resetValue = 1
            }

            return resetValue === undefined ? value : resetValue
        },
        gotoPage: function (event) {
            event.target.value = this.internalCurrentPage = this.getValidCurrentPage(event.target.value)
        }
    },

    computed: {
        internalPageCount: function () {
            if (typeof this.total === 'number') {
                return Math.ceil(this.total / this.internalPageSize)
            } else if (typeof this.pageCount === 'number') {
                return this.pageCount
            }
            return null
        }
    },

    watch: {
        currentPage: {
            immediate: true,
            handler: function (val) {
                this.internalCurrentPage = val
            }
        },

        pageSize: {
            immediate: true,
            handler: function (val) {
                this.internalPageSize = val
            }
        },

        internalCurrentPage: function (newVal, oldVal) {
            newVal = parseInt(newVal, 10)

            /* istanbul ignore if */
            if (isNaN(newVal)) {
                newVal = oldVal || 1
            } else {
                newVal = this.getValidCurrentPage(newVal)
            }

            if (newVal !== undefined) {
                this.$nextTick(function () {
                    this.internalCurrentPage = newVal
                    if (oldVal !== newVal) {
                        this.$emit('update:currentPage', newVal)
                        this.$emit('current-change', this.internalCurrentPage)
                    }
                })
            } else {
                this.$emit('update:currentPage', newVal)
                this.$emit('current-change', this.internalCurrentPage)
            }
        },

        internalPageCount: function (newVal) {
            /* istanbul ignore if */
            var oldPage = this.internalCurrentPage
            if (newVal > 0 && oldPage === 0) {
                this.internalCurrentPage = 1
            } else if (oldPage > newVal) {
                this.internalCurrentPage = newVal === 0 ? 1 : newVal
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../scss/common/pagination.scss';
</style>



// WEBPACK FOOTER //
// src/components/lib/pagination.vue